module.exports = __webpack_public_path__ + "img/checked_refund.da188ccb.png";